
import styled, { css, createGlobalStyle } from "styled-components";
import { px2rem } from "utils/browser/resizer";

// 侧边栏弹出时，body不滚动
export const GlobalStyle = createGlobalStyle`
	body.litb-m-fixscroll {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}
`;

export const LitbMHeader = styled.div`
	> div {
		z-index: 3000;
	}
`;
export const HeaderLayout = styled.section`
	height: ${px2rem(55)};
	border-top: 1px solid #eee;
	border-bottom: 1px solid #e2e2e2;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(12)} 0 ${px2rem(2.4)};
`;
export const HeaderSide = styled.section`
	width: ${px2rem(63)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const HeaderTitle = styled.h3`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: ${px2rem(50)};
	line-height: ${px2rem(50)};
	font-size: ${px2rem(18)};
	font-weight: 700;
	color: #333;
	text-align: center;
	border-bottom: 1px solid #d2d2d2;
	margin: 0;
	background: #fff;
	z-index: 122;
`;
export const HeaderIcon = styled.div`
	width: ${px2rem(30)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: ${px2rem(24)};
		height: ${px2rem(24)};
	}
`;
export const CartIcon = styled(HeaderIcon)`
	position: relative;
`;
export const Badge = styled.div`
	position: absolute;
	top: 0.375rem;
	right: -0.375rem;
	display: block;
	z-index: 10;
	background: var(--themeColor);
	color: #fff;
	min-width: ${px2rem(16)};
	height: ${px2rem(16)};
	text-align: center;
	line-height: ${px2rem(16)};
	padding: 0;
	font-size: ${px2rem(12)};
	font-weight: 400;
	border-radius: ${px2rem(8)};
	span {
		padding: 0 4px;
	}
`;
export const Title = styled.a`
	width: ${px2rem(160)};
	height: 100%;
	position: relative;
	> img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;
export const Cover = styled.div`
	position: fixed;
	top: 0;
	width: 100vw;
	height: 100%;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.4s ease;
	background: rgba(0, 0, 0, 0.6);
	> img {
		position: absolute;
		top: ${px2rem(15)};
		right: ${px2rem(50)};
		width: ${px2rem(24)};
		height: ${px2rem(24)};
	}
	${(props: { show: boolean }) =>
		props.show &&
		css`
			opacity: 1;
			pointer-events: auto;
		`};
`;
export const Side = styled.div`
	position: fixed;
	top: 0;
	left: -100vw;
	height: 100%;
	width: 77.3333333333vw;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #f5f5f5;
	transition: transform 0.4s ease;
	font-size: ${px2rem(14)};
	font-weight: normal;
	color: #333333;
	box-sizing: content-box;

	@supports (bottom: constant(safe-area-inset-bottom)) {
		padding-bottom: constant(safe-area-inset-bottom);
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		padding-bottom: env(safe-area-inset-bottom);
	}
	${(props: { show: boolean }) =>
		props.show &&
		css`
			transform: translate3d(100vw, 0, 0);
		`};
`;
const SideItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const NextIcon = styled.img`
	width: ${px2rem(16)};
	height: ${px2rem(16)};
	${(props: { deg: number }) =>
		css`
			transform: rotate(${props.deg}deg);
		`};
`;

export const CategoryList = styled.div`
	margin-top: ${px2rem(9)};
	padding-bottom: ${px2rem(9)};
	background: #fff;
`;
export const CategorySideItem = styled(SideItem)`
	box-sizing: content-box;
	padding: ${px2rem(8)};
	position: relative;
	${(props) => {
		if (props.border)
			return css`
				&::after {
					content: "";
					display: inline-block;
					width: 100%;
					height: 1px;
					position: absolute;
					bottom: 0;
					left: ${px2rem(8)};
					background-color: #ddd;
				}
			`;
	}}
`;
export const CategoryLeft = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
`;
export const GreyBg = styled.div`
	width: ${px2rem(44)};
	height: ${px2rem(44)};
	position: relative;
	margin-right: ${px2rem(6)};
	> img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	> div {
		position: absolute;
		top: 0;
		left: 0;
		background: #000;
		opacity: 0.03;
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
`;

export const SideBody = styled.section`
	flex: auto 1;
	padding-top: ${px2rem(50)};
`;

export const CategoryChildren = styled.div``;